export default __webpack_public_path__ + "static/media/amex_cards.481eb3cb.gif";